import { parse } from 'query-string';
import {
  LOCATION_CHANGE,
  SELECT_JOB
} from './../actions';

const initialState = {
  releaseMetricsInfo: {
    product: 'process',
    scenario: '',
    case: '',
    sinceVersion: '',
  },
  selectedJobs: []
};

const releaseMetricsPage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search || action.payload.pathname !== '/release-metrics') {
        return state;
      }

      // These are for the main selector:
      // p: product name
      // c: selected case name
      // s: selected scenario name
      // v: since Version
      // The names need to be short because they're part of the URL query.
      const { p, c, s, v } = parse(action.payload.search);

      return {
        ...state,
        releaseMetricsInfo: {
          product: p || 'process',
          case: c || '',
          scenario: s || '',
          sinceVersion: v || '',
        },
        selectedJobs: []
      };

    default:
      return state;
  }
};

export default releaseMetricsPage;

const getReleaseMetricsPage = state => state.releaseMetricsPage;
export const getReleaseMetricsInfo = state =>
  getReleaseMetricsPage(state).releaseMetricsInfo || initialState.releaseMetricsInfo;
export const getReleaseMetricsSelectedJobs = state =>
  getReleaseMetricsPage(state).selectedJobs;


// WEBPACK FOOTER //
// src/reducers/releaseMetricsPage.js